import sessionStore from "../../store/sessionStore";
import { getMsg, isNotEmpty } from "../../util/util";
import pocs from "../pocs";
const isLogged = () => {
    return !!(sessionStore.getAuth()) ? !!sessionStore.getAuth().tntocd : false;
}
const getUser = () => {
    return sessionStore.getAuth() ? sessionStore.getAuth() : null;
}
const login = (tksakicd, userid, passwordInput) => async () => {
    if (userid) {
        return new Promise((resolve, reject) => {
            pocs.login({ tksakicd: tksakicd, userid: userid, password: passwordInput })
                .then((response) => {
                    if (!!response.data) {
                        if (isNotEmpty(response.data.message)) {
                            reject(response);
                        } else {
                            //ログインできた場合はローカルストレージに保存
                            sessionStore.setAuth(response.data.data.loginDto);
                            resolve(response.data);
                            document.cookie = `JSESSIONID=${response.data.data.sessionid}`;
                            document.cookie = `XSRF-TOKEN=${response.data.data.token}`;
                        }
                    }
                })
                .catch(e => {
                    console.log(e);
                    reject(e);
                });
        })
    } else {
        return Promise.reject({ messageCode: "ESYS0090", message: getMsg("ESYS0090") });
    }
}

const logout = () => async (dispatch) => {
    return new Promise((resolve, reject) => {
        pocs.logout()
            .then(() => {
                sessionStore.resetAuth();
                document.cookie.replace(
                    /(?<=^|;).+?(?=\=|;|$)/g,
                    name => window.location.hostname
                        .split(/\.(?=[^\.]+\.)/)
                        .reduceRight((acc, val, i, arr) => i ? arr[i] = '.' + val + acc : (arr[i] = '', arr), '')
                        .map(domain => document.cookie = `${name}=;max-age=0;path=/;domain=${domain}`)
                );
                resolve(null);
            })
            .catch(e => {
                console.log(e);
                reject(e);
            });
    })
}
const authService = {
    isLogged,
    getUser,
    login,
    logout
}

export default authService;

